export default __webpack_public_path__ + "static/etoile-filante-241d47f1db0eac1100ca13e6e6e0c7c7.svg";